import { Trans } from '@lingui/react';
import React from 'react';
import { callAllHandlers, DropdownMenu, List, ProfileOutlined, Text } from '@landr/maestro';
import { openNetworkLink, getNetworkLink } from '@landr/core';
import { useLinkClickHandler } from '../../../../hooks/useLinkClickHandler.es.js';
import { useProfileProviderContext } from '../ProfileProvider/ProfileProvider.es.js';
import { ProfileTooltip } from './ProfileTooltip/ProfileTooltip.es.js';
import { ProfileCompletion } from './ProfileCompletion/ProfileCompletion.es.js';
import { useNavBarContext } from '../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { Links } from '../../../../../../enums/Links.es.js';

var UserProfileCompletionItem = function UserProfileCompletionItem() {
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env;
  var handleLinkClick = useLinkClickHandler();
  var handleOnclick = callAllHandlers(handleLinkClick(openNetworkLink, env, Links.MyProfile));
  var _useProfileProviderCo = useProfileProviderContext(),
    error = _useProfileProviderCo.error;
  if (error) {
    return null;
  }
  return /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    as: "a",
    onClick: handleOnclick,
    href: getNetworkLink(env, Links.MyProfile)
  }, /*#__PURE__*/React.createElement(List.ItemIcon, null, /*#__PURE__*/React.createElement(ProfileOutlined, null)), /*#__PURE__*/React.createElement(Text, {
    mr: "xxs"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "vERlcd"
  })), /*#__PURE__*/React.createElement(ProfileTooltip, null), /*#__PURE__*/React.createElement(List.ItemSecondaryAction, null, /*#__PURE__*/React.createElement(ProfileCompletion, null)));
};

export { UserProfileCompletionItem };
